import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useCreateFoetuses = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ pregnancyId, count }) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.post(
        `${tenantVal}/pregnancyfoetus/pregnancy/${pregnancyId}/create-multiple/${count}`
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pregnancies"] });
    },
    onError: (error) => console.error("Failed to create foetuses:", error),
    meta: { skipGlobalError: true },
  });
};
